import React from "react";
import styled from "styled-components";
import { useFilterContext } from "../context/Filter_context";
import { BsFillGridFill, BsList } from "react-icons/bs";

const Sort = () => {
  const {
    filtered_products: product,
    Gride_View,
    setGrideView,
    setListView,
    sort,
    upDateSort,
  } = useFilterContext();
  return (
    <Wrapper>
      <div className="btn-container">
        <button
          type="button"
          className={`${Gride_View ? "active" : null}`}
          onClick={setGrideView}
        >
          <BsFillGridFill />
        </button>
        <button
          type="button"
          className={`${!Gride_View ? "active" : null}`}
          onClick={setListView}
        >
          <BsList />
        </button>
      </div>
      <p>{product.length} Products found</p>
      <hr></hr>
      <form>
        <label htmlFor="sort"> Sort by</label>
        <select
          name="sort"
          id="sort"
          className="sort-input"
          value={sort}
          onChange={upDateSort}
        >
          {/* value={sort}  value of sort is coming for state  */}
          <option value="price-lowest">Price (Lowest)</option>
          <option value="price-highest">Price (highest)</option>
          <option value="name-a">Name (a-z)</option>
          <option value="name-z">Name (z-a)</option>
        </select>
      </form>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  padding: 7px;

  display: grid;
  grid-template-columns: auto auto 1fr auto;
  align-items: center;
  background: white;
  margin-bottom: 2rem;
  column-gap: 2rem;
  @media (max-width: 576px) {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 0.75rem;
    .btn-container {
      width: 50px;
    }
    label {
      display: inline-block;
      margin-right: 0.5rem;
    }
  }
  @media (min-width: 768px) {
    column-gap: 2rem;
  }
  p {
    text-transform: capitalize;
    margin-bottom: 0;
  }

  .btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 0.5rem;
    button {
      background: transparent;
      border: 1px solid var(--clr-black);
      color: var(--clr-black);
      width: 1.5rem;
      border-radius: var(--radius);
      height: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      svg {
        font-size: 1rem;
      }
    }
    .active {
      background: var(--clr-black);
      color: var(--clr-white);
    }
  }

  .sort-input {
    border-color: transparent;
    font-size: 1rem;
    text-transform: capitalize;
    padding: 0.25rem 0.5rem;
  }
  label {
    font-size: 1rem;
    text-transform: capitalize;
  }
`;

export default Sort;
